import { jsx as _jsx } from "react/jsx-runtime";
import React, { Suspense, useMemo } from 'react';
import styled, { StyleSheetManager } from 'styled-components';
import { PageLoading } from 'components/atoms/loading';
import { useAccountDataQuery } from 'queries/account';
import { NotFound } from 'routes/404';
const SignalAgentsApp = /*#__PURE__*/ React.lazy(()=>import('agentBuilder/SignalAgentsApp').then((module)=>({
            default: module.SignalAgentsApp
        })));
const SignalAgentsWrapper = styled.div`
  width: 100%;
  height: 100%;
`;
export const SignalAgentsRemote = ()=>{
    var _ref;
    var _accountData_accountMeta_features, _accountData_accountMeta;
    const { data: accountData } = useAccountDataQuery();
    const isScarletEnabled = (_ref = accountData === null || accountData === void 0 ? void 0 : (_accountData_accountMeta = accountData.accountMeta) === null || _accountData_accountMeta === void 0 ? void 0 : (_accountData_accountMeta_features = _accountData_accountMeta.features) === null || _accountData_accountMeta_features === void 0 ? void 0 : _accountData_accountMeta_features.scarlet) !== null && _ref !== void 0 ? _ref : false;
    // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
    const hostAPI = useMemo(()=>({
            // Signal agents currently doesn't request host components.
            renderComponent: ()=>null
        }), []);
    if (!isScarletEnabled) {
        return /*#__PURE__*/ _jsx(NotFound, {});
    }
    return /*#__PURE__*/ _jsx(Suspense, {
        fallback: /*#__PURE__*/ _jsx(PageLoading, {}),
        children: /*#__PURE__*/ _jsx(StyleSheetManager, {
            target: document.head,
            children: /*#__PURE__*/ _jsx(SignalAgentsWrapper, {
                className: "bg-[var(--scarlet-gray-80)] p-3",
                children: /*#__PURE__*/ _jsx(SignalAgentsApp, {
                    hostAPI: hostAPI
                })
            })
        })
    });
};
